// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__26lA5","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2hOC4"};